<template>
  <Loader v-if="this.isLoading" />
  <PreviewModal
    :modalMessage="modalMessage"
    :modalImage="this.$store.state.blogImageFileURL"
    :isImage="true"
    v-show="activeBlogImageModal"
    @close-modal="handleClose"
  />
  <div class="container mt-3 create-section">
    <p v-if="error" style="color: red; font-size: 16px">
      {{ errorMessage }}
    </p>
    <p class="create-topic">Enter Blog title</p>
    <div class="auth-field">
      <input
        type="text"
        class="auth-input mb-3"
        placeholder="Blog Title"
        v-model="blogTitle"
      />
    </div>
    <p class="create-topic">Add Blog Cover Image</p>
    <div class="auth-field">
      <label for="blog-image" class="blog-upload">Upload Cover Photo</label>
      <input
        ref="blogImage"
        id="blog-image"
        @change="fileChange"
        type="file"
        class="auth-file"
        accept=".png , .jpg"
        placeholder="Cover Image"
        style="display: none"
      />
      <p class="ml-4 mb-2" style="font-size: 14px">
        Selected photo: {{ this.$store.state.blogImage }}
      </p>
    </div>
    <button
      @click="openBlogImageModal"
      class="auth-button mt-0 mb-4 mr-3"
      v-if="this.$store.state.blogImage !== ''"
    >
      Preview Blog Cover
    </button>
    <button
      @click="removeBlogImage"
      style="background-color: #883737"
      class="auth-button mt-0 mb-4"
      v-if="this.$store.state.blogImage !== ''"
    >
      Remove Blog Image
    </button>
    <p class="create-topic">Write your blog</p>
    <QuillEditor
      contentType="html"
      v-model:content="blogHTML"
      theme="snow"
      toolbar="essential"
    />
    <div class="mb-5">
      <button class="auth-button mr-3">
        <router-link
          :to="{
            name: 'BlogPreview',
          }"
          >Preview Blog</router-link
        >
      </button>
      <button @click="submitPost" class="auth-button">Publish Blog</button>
    </div>
  </div>
</template>

<script>
import { QuillEditor } from "@vueup/vue-quill";
import PreviewModal from "../components/Modal.vue";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import firebase from "firebase/app";
import "firebase/storage";
import Loader from "../components/Loader.vue";

export default {
  name: "CreatePost",
  components: { QuillEditor, PreviewModal, Loader },
  data() {
    return {
      activeBlogImageModal: false,
      modalMessage: "This is your blog cover image",
      error: null,
      errorMessage: null,
      file: null,
      isLoading: false,
    };
  },
  computed: {
    blogTitle: {
      get() {
        return this.$store.state.blogTitle;
      },
      set(payload) {
        this.$store.commit("setBlogTitle", payload);
      },
    },
    blogHTML: {
      get() {
        return this.$store.state.blogHTML;
      },
      set(payload) {
        this.$store.commit("setBlogHTML", payload);
      },
    },
    blogImage() {
      return this.$store.state.blogImageName;
    },
  },
  methods: {
    fileChange() {
      this.file = this.$refs.blogImage.files[0];
      const fileName = this.file.name;
      this.$store.commit("setBlogImage", fileName);
      this.$store.commit("setBlogFile", this.file);
      this.$store.commit("setBlogImageFileURL", URL.createObjectURL(this.file));
    },
    handleClose() {
      this.activeBlogImageModal = false;
    },
    openBlogImageModal() {
      this.activeBlogImageModal = true;
    },
    removeBlogImage() {
      this.$store.commit("setBlogImage", "");
      this.$store.commit("setBlogFile", null);
      this.$store.commit("setBlogImageFileURL", "");
    },
    submitPost() {
      if (this.blogTitle !== "" && this.blogHTML !== null) {
        if (this.$store.state.blogImage) {
          const timestamp = Date.now();
          this.isLoading = true;
          const storageRef = firebase.storage().ref();
          const docRef = storageRef.child(
            `documents/BlogCoverImages/${timestamp}_${this.$store.state.blogImage}`
          );
          docRef.put(this.$store.state.blogFile).on(
            "state_changed",
            (snapshot) => {
              console.log(snapshot);
            },
            (err) => {
              console.log(err);
              this.loading = false;
            },
            async () => {
              const downloadURL = await docRef.getDownloadURL();
              const dataBase = await firebase
                .firestore()
                .collection("blogPosts")
                .doc();
              await dataBase.set({
                blogID: dataBase.id,
                blogHTML: this.blogHTML,
                blogCoverPhoto: downloadURL,
                blogImage: this.$store.state.blogImage,
                blogTitle: this.blogTitle,
                blogDate: timestamp,
                blogUser: this.$store.state.userProfile.uid,
              });
              await this.$store.dispatch("getPosts");
              this.isLoading = false;
              this.$router.push({
                name: "SingleBlog",
                params: { blogid: dataBase.id },
              });
            }
          );
          return;
        }
        this.error = true;
        this.errorMessage = "Please ensure you uploaded a cover photo!";
        setTimeout(() => {
          this.error = false;
        }, 5000);
        return;
      }
      this.error = true;
      this.errorMessage =
        "Please ensure Blog Title & Blog Post has been filled!";
      setTimeout(() => {
        this.error = false;
      }, 5000);
      return;
    },
  },
};
</script>

<style scoped>
.blog-upload {
  font-size: 18px;
}
.blog-upload:hover {
  cursor: pointer;
}
.create-topic {
  font-size: 24px;
}
.auth-file {
  font-size: 16px;
}
a {
  text-decoration: none;
  color: white;
}
</style>